<template>
  <v-dialog
    v-if="saler"
    persistent
    no-click-animation
    fullscreen
    v-model="showDialog"
    transition="dialog-bottom-transition"
  >
    <v-card max-width="768" tile>
      <v-card-title class="justify-end px-3 py-2">
        <a @click="closeDialog()" id="btn__3BJj3w+95E6mz+keTt7BKg==">
          <v-icon large> mdi-close </v-icon>
        </a>
      </v-card-title>
      <v-card-text class="text-center px-4">
        <v-row cols="12" class="mt-2" no-gutters>
          <v-col cols="12">
            <p class="mb-5 font--m-3" v-if="!localPayment.uuid"></p>
            <p class="mb-5 font--m-3" v-else>해당 송금건을 수정 또는 취소해주세요</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-card class="pb-0">
          <v-card-text class="pa-3">
            <p class="font--m-5">거래처명</p>
            <p v-if="saler" class="font--m-4 mb-0">{{ saler.name }}</p>
          </v-card-text>
          <v-card-text class="pa-3">
            <p class="font--m-5">주소</p>
            <p v-if="saler" class="font--m-4 mb-0">
              {{ saler.location }}
            </p>
          </v-card-text>
          <v-card-text class="pa-3 pb-0">
            <p class="font--m-5">금액</p>
            <v-text-field
              outlined
              placeholder="금액"
              class="mb-0"
              v-model="localPayment.amount"
              v-input-comma
              :error-messages="amountRules"
            ></v-text-field>
          </v-card-text>
          <v-card-text class="pa-3 pt-0">
            <p class="font--m-5" v-if="temps.length > 1">송금처</p>
            <div v-if="localPayment.uuid">
              {{ localPayment.wholesalerAccount.bank | bankCodeName }}
              {{ localPayment.wholesalerAccount.number }}
              {{ localPayment.wholesalerAccount.holderName }}
            </div>
            <div v-else>
              <v-select
                class="mb-2 font--m-5"
                :items="temps"
                hide-details
                outlined
                flat
                return-object
                v-model="localPayment.wholesalerAccount"
                v-if="temps.length > 1"
              >
                <template v-slot:selection="{ item }">
                  <span class="account-text">
                    {{ item.bank | bankCodeName }} {{ item.number }} {{ item.holderName }}
                  </span>
                  <span v-if="item.bank" class="verify-chip" :class="{ verified: item.isVerified }">
                    {{ item.isVerified !== false ? '인증' : '미인증' }} 계좌
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <span class="account-text">
                    {{ item.bank | bankCodeName }} {{ item.number }} {{ item.holderName }}
                  </span>
                  <span v-if="item.bank" class="verify-chip" :class="{ verified: item.isVerified }">
                    {{ item.isVerified !== false ? '인증' : '미인증' }} 계좌
                  </span>
                </template>
              </v-select>
              <div v-if="!localPayment.wholesalerAccount.uuid">
                <BankSelect :emitSelectBank.sync="bank" />
                <v-text-field
                  v-model="choiceBank.number"
                  outlined
                  hide-details
                  flat
                  autocomplete="on"
                  placeholder="계좌번호"
                  class="mt-2 mb-2"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                ></v-text-field>
              </div>
            </div>
          </v-card-text>
          <v-card-text class="pa-3 pb-0">
            <p class="font--m-5">
              입금자명
              <span class="font--m-7"
                >(거래처에 표시될 <strong>입금자명</strong>을 알려주세요)</span
              >
            </p>
            <v-select
              label="입금자명을 선택해주세요"
              :items="depositNames"
              v-model="localPayment.depositName"
              solo
              item-text="name"
              item-value="name"
              class="elevation-0"
              height="56"
            >
            </v-select>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-text class="text-center color--pinkred-110 font--m-5 mt-5 mb-5">
        *송금 요청 시 5분 후 송금이 진행되며,<br />
        은행 점검 시간인 오후 11시부터 오전 1시 30분까지<br />
        잠시 쉬었다 송금됩니다.
      </v-card-text>
      <v-card-actions v-if="this.$route.name === 'payments/form'">
        <BasicButton
          id="btn__LdUkGvIEp0O03Gdf7izKag=="
          class="pa-3 mb-10"
          @click="saveBnpl()"
          :loading="saveBnplLoading"
          :disabled="saveBnplLoading || !isValidAll"
          >등록하기</BasicButton
        >
      </v-card-actions>
      <!-- 수정 폼 사용 안함 -->
      <!-- <v-card-actions v-else>
        <BasicButton
          id="btn__nrfC3jFGJUqhHx0cYbS/5w=="
          class="color--buynow mb-10"
          color="white"
          style="width: 47%"
          @click="deleteBnpl()"
          :loading="deleteBnplLoading"
          :disabled="!localPayment.wholesalerAccount.uuid || deleteBnplLoading"
          >송금취소</BasicButton
        >
        <v-spacer></v-spacer>
        <BasicButton
          id="btn__j+thbByBYUO41fszyYywBA=="
          class="mb-10"
          style="width: 47%"
          @click="editBnpl()"
          :loading="saveBnplLoading"
          :disabled="!localPayment.wholesalerAccount.uuid || saveBnplLoading || !isValidAll"
          >수정하기</BasicButton
        >
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>

<script>
import { defaultApi } from '@/plugins/api/defaultApi'
import { mapActions, mapState } from 'vuex'
import { simpleClone } from '@/util'

import BankSelect from '@/components/bank/BankSelect.vue'
import { commaFormat, commaRemove } from '@/filter/number'

export default {
  props: {
    wholesalerId: {
      type: String,
      required: true,
    },
    payment: {
      type: Object,
    },
  },
  data() {
    return {
      saler: null,
      localPayment: {
        uuid: null,
        wholesalerAccount: {
          bank: null,
          holderName: null,
          isVerified: false,
          number: null,
          uuid: null,
        },
        depositName: null,
      },
      showDialog: true,
      isLoading: false,
      isAccountLoading: false,
      accountList: null,
      bank: null,
      choiceBank: {
        bank: null,
        number: null,
        holderName: null,
      },
      saveBnplLoading: false,
      amountRules: [],
      deleteBnplLoading: false,
      account: null,
      depositNameRules: [],
      depositNames: [],
    }
  },
  components: {
    BankSelect,
  },
  computed: {
    ...mapState('bnpl', ['availableAmount']),
    bankIsValid() {
      return !!this.choiceBank.bank && !!this.choiceBank.number && this.choiceBank.number.length > 6
    },
    isValidAll() {
      if (!this.localPayment.wholesalerAccount.uuid) {
        if (!this.bankIsValid) {
          return false
        }
      }

      return this.isValidAmount && this.isValidDepositName
    },
    temps() {
      const temp = [
        { accountHolder: null, bank: null, number: '직접 입력', isVerified: true },
        ...this.saler.wholesalerAccounts,
      ]
      return temp
    },
    sendPayment() {
      const number = this.localPayment.wholesalerAccount.number
        .replace(/[^0-9.]/g, '')
        .replace(/(\..*)\./g, '$1')
      const modifiedPayment = {
        ...this.localPayment,
        amount: commaRemove(this.localPayment.amount),
        depositName: this.localPayment.depositName,
        wholesalerAccount: {
          ...this.localPayment.wholesalerAccount,
          number,
        },
      }
      return modifiedPayment
    },
    isValidAmount() {
      const amount = this.sendPayment?.amount
      if (!amount) {
        return false
      }
      return amount <= this.availableAmount?.available
    },
    isValidDepositName() {
      if (!this.localPayment.depositName) {
        return false
      }
      return this.localPayment.depositName.length < 12
    },
  },
  watch: {
    'bank'(v) {
      if (v) {
        this.choiceBank.bank = v.bank
      } else {
        this.localPayment.wholesalerAccount.holderName = null
      }
    },
    'choiceBank.bank': {
      deep: true,
      handler() {
        this.choiceBank.holderName = null
        this.localPayment.wholesalerAccount.holderName = null
      },
    },
    'choiceBank.number'() {
      this.choiceBank.holderName = null
      this.localPayment.wholesalerAccount.holderName = null
    },
    async 'localPayment.wholesalerAccount'(value, beforeValue) {
      if (value === beforeValue) return
      await this.setDepositNameFromHistory(value.uuid)
    },
    'localPayment.amount'() {
      if (this.sendPayment.amount > this.availableAmount.available) {
        this.amountRules = [
          `이용 가능한 금액(${commaFormat(this.availableAmount.available)}원)을 초과하였습니다.`,
        ]
      } else if (this.sendPayment.amount < 1 || !this.sendPayment.amount) {
        this.amountRules = [`금액은 1원 이상 입력해주세요`]
      } else {
        this.amountRules = null
      }
    },
    'localPayment.depositName'() {
      if (this.localPayment.depositName && this.localPayment.depositName.length > 11) {
        this.depositNameRules = ['입금자명은 12자를 초과할 수 없습니다.']
      } else if (this.localPayment.depositName === '') {
        this.depositNameRules = ['입금자명을 1자 이상 입력해주세요']
      } else {
        this.depositNameRules = null
      }
    },
  },
  async created() {
    await this.getSalerDetail()
    await this.getAvailableAmount()
    await this.getPaymentsFiltering()
    this.depositNames = await this.getUsersExtraDepositNames({ isActive: true })

    if (!this.payment) {
      const temp = this.temps.filter(
        (t) => t.number === this.account.results[0]?.wholesalerAccount.number,
      )
      if (this.temps.length > 1 && temp.length > 0) {
        this.localPayment.wholesalerAccount = temp[0]
      } else if (this.temps.length > 1 && temp.length < 1) {
        this.localPayment.wholesalerAccount = this.temps[1]
      } else {
        this.localPayment.wholesalerAccount = this.temps[0]
      }
    } else {
      this.localPayment = simpleClone(this.payment)
    }
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('wholesaler', ['addWholesalerAccount', 'getWholesalerDetail']),
    ...mapActions('bnpl', [
      'savePayment',
      'getAvailableAmount',
      'deletePayment',
      'getPayments',
      'getDepositName',
      'getUsersExtraDepositNames',
      'checkBeforeOrDelete',
    ]),
    ...mapActions('code/bank', ['getBankName']),
    async getSalerDetail() {
      this.saler = await this.getWholesalerDetail({ uuid: this.wholesalerId })
    },
    async getPaymentsFiltering() {
      this.account = await this.getPayments({
        'wholesalerAccount.wholesaler.uuid': this.wholesalerId,
      })
    },
    async getAccountName() {
      try {
        if (this.bankIsValid !== true) {
          return
        }
        this.isLoading = true
        const { data } = await defaultApi.getBankAccountHolderName(this.choiceBank)

        const { isConfirmed } = await this.$swal.basic.confirm({
          html: `
              <b class="font--m-4">
                ${await this.getBankName(this.choiceBank.bank)} ${this.choiceBank.number} ${
            data.holderName
          }
              </b>
              <br />
              <br />
              해당 계좌로 ${commaFormat(this.sendPayment.amount)}원 송금을 등록 합니다.<br />

              `,
        })

        if (isConfirmed !== true) {
          return
        }

        this.choiceBank.holderName = data.holderName
        this.localPayment.wholesalerAccount.holderName = data.holderName
        const param = {
          ...this.choiceBank,
          wholesaler: this.saler.uuid,
        }
        const result = await this.addWholesalerAccount(param)
        await this.getSalerDetail()
        this.localPayment.wholesalerAccount = result
        return result
      } finally {
        this.isLoading = false
      }
    },
    async closeDialog() {
      this.$emit('emitShow', false)
    },
    async saveBnpl() {
      try {
        this.saveBnplLoading = true

        if (this.sendPayment.amount > this.availableAmount.available) {
          await this.$swal.basic.alert({
            html: `이용 가능한 금액은 <b>${commaFormat(
              this.availableAmount.available,
            )}원</b> 입니다. <br /> 이용 가능한 금액을 초과하셨습니다.`,
          })
          return
        }
        if (!this.sendPayment.wholesalerAccount.uuid) {
          const r = await this.getAccountName()
          if (!r) {
            return
          }
        }

        if (this.sendPayment.wholesalerAccount?.isVerified !== true) {
          const { isConfirmed } = await this.$swal.basic.confirm({
            html: `
                계좌 검증이 필요합니다.<br/>
                실제 계좌 확인 업무는 아래 시간에 진행 되며,<br/>
                송금은 검증 이후 진행 됩니다.<br/>
                <span style="color: red">검증 시간 : 영업일 10시 ~ 18시</span>
              `,
          })
          if (isConfirmed !== true) {
            return
          }
        }

        await this.savePayment(this.sendPayment)
        await this.closeDialog()
      } finally {
        this.saveBnplLoading = false
      }
    },
    async deleteBnpl() {
      try {
        // 취소 가능 시간인지 검사
        const isValid = await this.checkBeforeOrDelete(this.localPayment.uuid)
        if (!isValid) {
          await this.$router.replace({
            name: 'payments/detail',
            params: { uuid: this.localPayment.uuid },
          })
          return
        }

        const { isConfirmed } = await this.$swal.basic.confirm({
          html: `
              <b class="font--m-4">
              해당 송금요청을 취소할까요?
              </b>
              `,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
        })

        if (isConfirmed !== true) {
          return
        }

        this.deleteBnplLoading = true
        await this.deletePayment(this.localPayment)
        await this.closeDialog()
      } finally {
        this.deleteBnplLoading = false
      }
    },
    async setDepositNameFromHistory(accountUuid) {
      if (!accountUuid) return
      const { depositName } = await this.getDepositName({ uuid: accountUuid })
      const latestDeposit = this.depositNames.find((e) => e.name === depositName)

      if (latestDeposit) {
        this.localPayment.depositName = latestDeposit.name
      }
    },
    async editBnpl() {
      const isValid = await this.checkBeforeOrDelete(this.localPayment.uuid)
      if (!isValid) {
        await this.$router.replace({
          name: 'payments/detail',
          params: { uuid: this.localPayment.uuid },
        })
        return
      }
      await this.saveBnpl()
    },
  },
}
</script>
<style lang="scss" scoped>
.amount {
  padding: 0 15px;
  border-radius: black 5px;
}
::v-deep .v-select.v-text-field--solo .v-input__slot {
  box-shadow: none !important;
  border: 1px solid $gray-60;
}

.account-text {
  padding-right: 6px;
  word-break: keep-all;
}

.verify-chip {
  width: 69px;
  min-width: 69px;
  padding: 1px 6px;
  border: 1px solid currentColor;
  border-radius: 18px;
  font-size: 12px !important;
  text-align: center;

  &:not(.verified) {
    border-color: $pinkred-100;
    color: $pinkred-110;
  }
  &.verified {
    border-color: $primary-100;
    color: $primary-110;
  }
}
</style>
